import { inject } from '@angular/core';
import { AppStateService, GoogleAnalyticsService, HttpErrorService, StationsCheckoutService, StationsService } from '../../../services';
import { distinctUntilChanged } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CheckoutTotals, ProcessOrderResponse } from '../../../models';
import { GAEventAction, PaymentStatus, PaymentType, PublicRoutes } from '../../../enums';
import { MessageService } from 'primeng/api';
import { NavigationExtras, Router } from '@angular/router';

/** when extending this class be sure to implement ngOnInit,
 * @Input()
 * override notesMessage = 'Notes';
 */
export abstract class NgxAimStationOverviewClass {
  //   @Input()
  //   override notesMessage = 'Notes';

  //   ngOnInit {
  //   this.init();
  // }

  checkoutService = inject(StationsCheckoutService);
  httpErrorService = inject(HttpErrorService);
  appState = inject(AppStateService);
  messageService = inject(MessageService);
  router = inject(Router);
  gaService = inject(GoogleAnalyticsService);
  stationsService = inject(StationsService);

  station = this.stationsService.getSelectedStation();
  duration = this.stationsService.getSelectedDuration()! / 60;
  guests = this.stationsService.getSelectedAmountOfGuests();
  items = this.stationsService.getSelectedAddOns();
  date = this.stationsService.getSelectedDate();
  time = this.stationsService.getSelectedTime();
  needsRso = this.stationsService.getSelectedNeedsRSO();
  routes = PublicRoutes;
  notesMessage = 'Enter notes here';
  notes = '';

  totals$ = this.checkoutService.totals$.pipe(
    distinctUntilChanged(),
    takeUntilDestroyed(),
  );
  totals: CheckoutTotals = {
    items: 0,
    shipping: 0,
    tax: 0,
    total: 0,
  }
  isProcessing = false;
  showError = false;

  init() {
    this.totals$.subscribe(totals => {
      this.totals = totals;
    });
  }

  onCompleteClick() {
    this.stationsService.Notes = this.notes;
    if (this.appState.paymentType === PaymentType.NONE && this.totals.total !== 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Failed',
        detail: 'Cannot not check out at this time. No payment processor',
        key: 'app-toast'
      });
      return;
    }

    this.isProcessing = true;
    this.checkoutService.checkout().subscribe({
      next: (res) => this.handleCheckoutResponse(res),
      error: (err) => this.onError(err),
    });
  }

  handleCheckoutResponse(res: ProcessOrderResponse) {
    this.isProcessing = false;
    if (res.paymentStatus === PaymentStatus.APPROVED) {
      this.emitGaEvent(res);
      this.checkoutService.reset();

      const navigationExtras: NavigationExtras = {
        state: {
          orderId: res.orderId,
        },
      }
      this.router.navigate([PublicRoutes.STATIONS, PublicRoutes.GROUPS, this.stationsService.getSelectedGroup()!.Id, PublicRoutes.STATION_COMPLETE], navigationExtras);
    } else {
      this.showError = true;
    }
  }

  emitGaEvent(res: ProcessOrderResponse) {
    this.gaService.emitEvent(GAEventAction.PURCHASE, {
      transaction_id: res.orderId,
      currency: 'USD',
      value: this.totals.items,
      tax: this.totals.tax,
      shipping: this.totals.shipping,
      items: [{
        item_id: this.stationsService.getSelectedStation()?.Id,
        item_name: this.stationsService.getSelectedStation()?.WebDescription,
        price: this.totals.items,
        quantity: 1,
      }],
    });
  }

  onError(err: any) {
    this.isProcessing = false;
    this.httpErrorService.onHttpError(err, `We couldn't process your order`);
  }
}
